"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _inputParts = require("./inputParts");

var _Drop = _interopRequireDefault(require("../Drop"));

var _Keyboard = _interopRequireDefault(require("../Keyboard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RenderSuggestions = function RenderSuggestions(props) {
  var suggestions = props.suggestions,
      onSelect = props.onSelect,
      activeSuggestionIndex = props.activeSuggestionIndex;
  return /*#__PURE__*/_react["default"].createElement(_inputParts.Suggestions, null, suggestions.map(function (suggestion, index) {
    return /*#__PURE__*/_react["default"].createElement(_inputParts.Suggestion, {
      key: "".concat(suggestion.key || suggestion.value),
      onClick: function onClick() {
        return onSelect(suggestion);
      },
      active: index === activeSuggestionIndex
    }, suggestion.value);
  }));
}; // todo: add icon


var Input = function Input(props) {
  var suggestions = props.suggestions;
  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      firstLoad = _useState2[0],
      setFirstLoad = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDrop = _useState6[0],
      setDropState = _useState6[1];

  var _useState7 = (0, _react.useState)(-1),
      _useState8 = _slicedToArray(_useState7, 2),
      activeSuggestionIndex = _useState8[0],
      setActiveSuggestionIndex = _useState8[1];

  var rest = _objectSpread({}, props);

  delete rest.onSuggestionsOpen;
  delete rest.onSuggestionsClose; // so we can manage in component onChange()

  delete rest.onChange; // needed so that input does not invoke onSelect when text input is clicked

  delete rest.onSelect;
  delete rest.onEnter;
  var resetTimer;

  var resetSuggestions = function resetSuggestions() {
    clearTimeout(resetTimer);
    resetTimer = setTimeout(function () {
      if (suggestions && suggestions.length) {
        setDropState(true);
        setActiveSuggestionIndex(-1);
      }
    }, 10);
  };

  (0, _react.useEffect)(function () {
    return (// function will be called on component unmount
      function () {
        clearTimeout(resetTimer);
      }
    );
  }, []);
  (0, _react.useEffect)(function () {
    var onSuggestionsOpen = props.onSuggestionsOpen,
        onSuggestionsClose = props.onSuggestionsClose;

    if (showDrop && onSuggestionsOpen) {
      onSuggestionsOpen();
    } else if (onSuggestionsClose) {
      onSuggestionsClose();
    }
  }, [showDrop]);
  (0, _react.useEffect)(function () {
    if (!showDrop && !firstLoad && props.suggestions && props.suggestions.length) {
      setFirstLoad(false);
      resetSuggestions();
    }
  }, [suggestions]);

  var onChange = function onChange(event) {
    var externalOnChange = props.onChange;
    setFirstLoad(false);
    resetSuggestions();

    if (externalOnChange) {
      externalOnChange(event);
    }
  };

  var onClickSuggestion = function onClickSuggestion(suggestion) {
    var onSelect = props.onSelect;
    setDropState(false);

    if (onSelect) {
      onSelect(suggestion);
    }
  };

  var onEsc = function onEsc(event) {
    // we have to stop both synthetic events and native events
    // drop and layer should not close by pressing esc on this input
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setDropState(false);
  };

  var onSuggestionSelect = function onSuggestionSelect(event) {
    var onSelect = props.onSelect,
        onEnter = props.onEnter;
    setDropState(false);
    setFocus(false);

    if (activeSuggestionIndex >= 0) {
      event.preventDefault(); // prevent submitting forms

      var suggestion = suggestions[activeSuggestionIndex];

      if (onSelect) {
        onSelect(suggestion);
      }

      setActiveSuggestionIndex(-1);
    } else if (onEnter) {
      onEnter();
    }
  };

  var onPreviousSuggestion = function onPreviousSuggestion(event) {
    if (suggestions && suggestions.length > 0 && showDrop) {
      event.preventDefault();
      var index = Math.max(activeSuggestionIndex - 1, 0);
      setActiveSuggestionIndex(index);
    }
  };

  var onNextSuggestion = function onNextSuggestion(event) {
    if (suggestions && suggestions.length > 0) {
      if (!showDrop) {
        resetSuggestions();
      } else {
        event.preventDefault();
        var index = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
        setActiveSuggestionIndex(index);
      }
    }
  };

  var drop;

  if (showDrop) {
    drop = /*#__PURE__*/_react["default"].createElement(_Drop["default"], _extends({
      target: inputRef.current,
      onClickOutside: function onClickOutside() {
        return setDropState(false);
      },
      onEsc: function onEsc() {
        return setDropState(false);
      }
    }, rest), /*#__PURE__*/_react["default"].createElement(RenderSuggestions, {
      suggestions: suggestions,
      onSelect: onClickSuggestion,
      activeSuggestionIndex: activeSuggestionIndex
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_inputParts.Container, rest, /*#__PURE__*/_react["default"].createElement(_Keyboard["default"], {
    onEnter: onSuggestionSelect,
    onEsc: onEsc,
    onUp: onPreviousSuggestion,
    onDown: onNextSuggestion
  }, /*#__PURE__*/_react["default"].createElement(_inputParts.StyledInput, _extends({
    ref: inputRef,
    autoComplete: "off"
  }, rest, {
    focus: focus,
    onFocus: function onFocus() {
      setFocus(true);
      resetSuggestions();
    },
    onBlur: function onBlur() {
      setFocus(false);
    },
    onChange: onChange
  }))), drop);
};

var _default = Input;
exports["default"] = _default;